import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'iovisit-theme/components';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  download_file_label: {
    id: 'download_file_label',
    defaultMessage: 'Scarica brochure',
  },
  download_link_label: {
    id: 'download_link_label',
    defaultMessage: 'Scarica APP',
  },
});

const DownloadApp = ({ content, showLabel }) => {
  const intl = useIntl();
  const userLabel = content?.download_label;

  return (
    <div className="page-download-app">
      {content?.download_link ? (
        /* external link */
        <UniversalLink
          href={content.download_link}
          title={intl.formatMessage(messages.download_link_label)}
        >
          <Icon prefix="fas" icon="download" className="icon" />
          {showLabel && (
            <span className="icon-label">
              {userLabel
                ? userLabel
                : intl.formatMessage(messages.download_link_label)}
            </span>
          )}
        </UniversalLink>
      ) : content?.download_file ? (
        /* download file */
        <UniversalLink
          href={content.download_file.download}
          title={intl.formatMessage(messages.download_file_label)}
        >
          <Icon prefix="fas" icon="download" className="icon" />
          {showLabel && (
            <span className="icon-label">
              {userLabel
                ? userLabel
                : intl.formatMessage(messages.download_file_label)}
            </span>
          )}
        </UniversalLink>
      ) : (
        <></>
      )}
    </div>
  );
};
export default DownloadApp;
